<div class="row">
  <div class="col-6">
    <div class="table-responsive">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">{{'price-list.manage.category' | translate}}</th>
            <th scope="col">{{'price-list.manage.name' | translate}}</th>
            <th scope="col">{{'price-list.manage.extraInfo' | translate}}</th>
            <th scope="col">{{'price-list.manage.price' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let category of priceList.productCategories">
            <ng-container *ngFor="let product of category.products; first as isFirst; last as isLast; let i = index">
              <tr [ngClass]="{'bluBottomLine': isLast}">
                <td class="text-center">
                  <input type="checkbox" [value]="product.id" [checked]="productIdsArray.indexOf(product.id) !== -1"
                    (change)="onCheckboxChange($event)" />
                </td>
                <td width="150" scope="row">{{category.name}}</td>
                <td width="250">
                  {{product.name}}
                </td>
                <td width="250">
                  {{product.extraInfo}}
                </td>
                <td width="150">{{product.price | currency: eventCurrency + ' '}}</td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  <div class="col">
    <app-multiple-product-options [disableSaveButton]="disableSaveButton" [productIdsArray]="productIdsArray" [eventCurrency]="eventCurrency"
      (afterOptionsAdded)="onOptionsAdded()"></app-multiple-product-options>
  </div>
</div>
